import { $amplitudeExperimentsAtom } from '@client/core/atoms/amplitude.js';

import { debug } from './.debug.js';
import { Api } from './Api/index.js';

export namespace LazyLoad {
  const DEFAULT_RENDER_MARGIN_PERCENT = 10;
  const DEFAULT_FETCH_MARGIN_PERCENT = 30;
  const DEFAULT_MOBILE_SCALING = 1.0;

  export async function enable(...abortSignals: ReadonlyArray<AbortSignal>) {
    const lazyLoadConfig = getConfig();

    debug.message('Enabling lazy load', lazyLoadConfig).info((log) => log());

    await Api(...abortSignals)
      .pubads()
      .enableLazyLoad(lazyLoadConfig);
  }

  export function getConfig() {
    const { experiments, payloads } = $amplitudeExperimentsAtom.get();
    const experimentKey = 'gam-lazyloading-rendermargin';
    const experiment = experiments[experimentKey];
    const payload = payloads[experimentKey];

    const config = {
      renderMarginPercent: DEFAULT_RENDER_MARGIN_PERCENT,
      fetchMarginPercent: DEFAULT_FETCH_MARGIN_PERCENT,
      mobileScaling: DEFAULT_MOBILE_SCALING
    } satisfies googletag.LazyLoadOptionsConfig;

    if (!(experiment && payload)) return config;

    const keys = [
      'renderMarginPercent',
      'fetchMarginPercent',
      'mobileScaling'
    ] as const satisfies ReadonlyArray<keyof googletag.LazyLoadOptionsConfig>;

    for (const key of keys) {
      if (typeof payload[key] === 'number') config[key] = payload[key];
    }

    return config;
  }
}
